import { render, staticRenderFns } from "./btnDateAndHours.vue?vue&type=template&id=36ddeec6&"
import script from "./btnDateAndHours.vue?vue&type=script&lang=js&"
export * from "./btnDateAndHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports